<script>
import GenericCrud from "@forms/GenericCrud.vue";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Parametro"
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Descrição" label-for="descricao">
        <b-form-input
          id="nome"
          v-model="item.nome"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1" label="Valor Textual" label-for="valor">
        <b-form-input
          id="valor"
          v-model="item.valor"
          type="text"
          :disabled="!this.editForm"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1" label="Valor Numérico" label-for="valorNumerico">
        <b-form-input
          id="valor"
          v-model="item.valorNumerico"
          type="number"
          :disabled="!this.editForm"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1" label="Valor Inteiro" label-for="valorInteiro">
        <b-form-input
          id="valor"
          v-model="item.valorInteiro"
          type="number"
          :disabled="!this.editForm"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-1" label="Valor Data" label-for="data">
        <b-form-datepicker
          id="data"
          v-model="item.data"
          :disabled="!this.editForm"
          placeholder="Selecione uma data"
          :hide-header="true"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
